import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import WhoWeAre from './components/WhoWeAre';
import HowWeGenerate from './components/HowWeGenerate';
import WhatWeBuild from './components/WhatWeBuild';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="relative min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <WhoWeAre />
      <HowWeGenerate />
      <WhatWeBuild />
      <CTASection />
      <Footer />
    </main>
  );
}